import firebase from "../constants/firebase";
import { USERS } from "../constants/collections";

export const setUserProfile = async (
  user,
  registration,
  unAuthorized = false,
) => {
  const db = firebase.firestore();
  const userRef = db.collection(USERS).doc(user.user.uid);
  let userData = {
    displayName: user.user.displayName,
    photoURL:
      (registration && registration.photo && registration.photo.url) ||
      user.user.photoURL,
    email: user.user.email,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    roles: !unAuthorized
      ? firebase.firestore.FieldValue.arrayUnion(registration.role.value)
      : null,
    status: !unAuthorized ? "enabled" : "disabled",
    schools: registration ? registration.schools : [],
    profileType: registration && registration.profileType,
    profileId: registration && registration.profileId,
  };
  return await userRef.set(userData, { merge: true });
};

export const getAppUserToken = async () => {
  const user = firebase.auth().currentUser;
  if (!user) return null;
  const accessToken = await user.getIdToken();
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  return `${projectId} ${accessToken}`;
};

export const fetchWithAuth = async (url, options = {}) => {
  try {
    let token = await getAppUserToken();
    if (!token) throw new Error("No user logged in");

    const headers = { ...options.headers, Authorization: token };
    let response = await fetch(url, { ...options, headers });

    // If unauthorized (401) or forbidden (403), try refreshing token once
    if (response.status === 401 || response.status === 403) {
      console.warn(
        `Auth check failed (${response.status}). Attempting token refresh and retry...`,
      );

      const user = firebase.auth().currentUser;
      if (user) {
        try {
          // Force refresh
          const newToken = await user.getIdToken(true);

          // Reconstruct header manually to ensure we use the FRESH token
          const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
          const authHeader = `${projectId} ${newToken}`;

          headers.Authorization = authHeader;

          console.log("Token refreshed. Retrying request...");
          // Small delay to ensure backend sees the new issue time if clock skew exists
          await new Promise((r) => setTimeout(r, 1000));

          const retryResponse = await fetch(url, { ...options, headers });
          console.log(`Retry response status: ${retryResponse.status}`);
          return retryResponse;
        } catch (refreshErr) {
          console.error("Token refresh failed:", refreshErr);
          throw refreshErr;
        }
      }
    }
    return response;
  } catch (error) {
    console.error("fetchWithAuth error:", error);
    throw error;
  }
};
